// extracted by mini-css-extract-plugin
export default {"label":"EditUserRoleModal_label__PslXm","para":"EditUserRoleModal_para__RMqzP","forgetPassword":"EditUserRoleModal_forgetPassword__EK1pr"};